import { useEffect } from 'react'
import { concepts, lessons } from '../data/foundations'
import type { Progress } from '../types/progress'

interface Options { progress: Progress; startLesson(lessonId: string): void }

export function useWebMcp({ progress, startLesson }: Options) {
  useEffect(() => {
    const context = document.modelContext
    if (!context?.registerTool) return
    const lifecycle = new AbortController()
    const register = async () => {
      await context.registerTool({
        name: 'read_learning_progress', title: '读取学习进度', description: '读取当前设备上的 Foundations V1 课程、星星与多层掌握进度。',
        inputSchema: { type: 'object', properties: {}, additionalProperties: false }, annotations: { readOnlyHint: true, untrustedContentHint: false },
        execute: () => ({ inventoryVersion: progress.inventoryVersion, currentConceptId: progress.currentConceptId, completedLessonCount: progress.completedLessons.length, stars: progress.stars, plantLevel: progress.plantLevel, blendingMastery: progress.blendingMastery.masteryScore, segmentingMastery: progress.segmentingMastery.masteryScore }),
      }, { signal: lifecycle.signal })
      await context.registerTool({
        name: 'start_phonics_lesson', title: '开始拼读课程', description: '打开一个已解锁的课程，但不会替儿童完成答题。',
        inputSchema: { type: 'object', properties: { lessonId: { type: 'string', description: 'Foundations V1 lesson ID' } }, required: ['lessonId'], additionalProperties: false }, annotations: { readOnlyHint: false, untrustedContentHint: false },
        execute: (input: unknown) => {
          const lessonId = typeof input === 'object' && input !== null && 'lessonId' in input ? String(input.lessonId) : ''
          const lesson = lessons.find((item) => item.id === lessonId)
          if (!lesson) throw new Error('找不到这个课程')
          const currentOrder = concepts.find((item) => item.id === progress.currentConceptId)?.order ?? 1
          const lessonOrder = concepts.find((item) => item.id === lesson.conceptId)?.order ?? Number.POSITIVE_INFINITY
          if (lessonOrder > currentOrder) throw new Error('这个课程还没有解锁')
          startLesson(lessonId)
          return { opened: true, lessonId }
        },
      }, { signal: lifecycle.signal })
    }
    void register().catch(() => undefined)
    return () => lifecycle.abort()
  }, [progress, startLesson])
}
